import { Inline } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Pill } from "PFComponents/pill";
import { Typography } from "PFComponents/typography";

type ActivityTagPillProps = {
  tagName: string;
};

export const ActivityTagPill = ({ tagName }: ActivityTagPillProps) => (
  <Pill title={tagName} small>
    <Inline alignItems="center">
      <Icon name="tag" size="xs" />
      <Typography variant="labelRegular">{tagName}</Typography>
    </Inline>
  </Pill>
);
